import React, { useState, useEffect } from 'react';
import { COS_URL } from '../../../const/constants.js';
import { filterTree } from '../../../utils/index';
import { getRecentMenu } from '../../../api';
import { Menu, Input, Popup } from 'tdesign-react';
import './index.css';
import { isLogin } from '../../../utils/index.js';
import { useHistory } from "react-router-dom";
import { useMenuStore } from '../../../store';

const { MenuItem, SubMenu } = Menu;

export default function Sider() {
  // 从 menuStore 获取状态（使用选择器确保正确订阅）
  const action = useMenuStore(state => state.action);
  const navItems = useMenuStore(state => state.navItems);
  const recentMenu = useMenuStore(state => state.recentMenu);
  const isMenuCollapsed = useMenuStore(state => state.isMenuCollapsed);
  const expandedKeys = useMenuStore(state => state.expandedKeys);
  // 从 menuStore 获取操作函数
  const {
    setCurrentMenu,
    setRecentMenu,
    setMenuCollapsed,
    setExpandedKeys
  } = useMenuStore();

  // 本地 UI 状态
  const [filteredNavItems, setFilteredNavItems] = useState(navItems);
  const [showSearch, setShowSearch] = useState(false);
  const [searchVal, setSearchVal] = useState('');

  const history = useHistory();

  const getRecentMenuList = async (menuList) => {
    try {
      const res = await getRecentMenu();
      if (!res.error) {
        const allMenuItems = menuList.map(i => i.children).flat();
        const _recentMenu = res.Data.map(menuAction => {
          const foundMenu = allMenuItems.find(i => i.action === menuAction);
          return foundMenu || null;
        }).filter(i => !!i);
        setRecentMenu(_recentMenu);
      }
    } catch (e) {
      console.log('getRecentMenuList error');
    }
  };

  useEffect(() => {
    setFilteredNavItems(navItems);
    if (isLogin) {
      getRecentMenuList(navItems);
    }
  }, [navItems]);

  const searchMenu = (e) => {
    if (e) {
      const searchList = filterTree(navItems, (item) => {
        return item.title.includes(e) || item.text?.includes(e) || item.action?.includes(e);
      });
      setFilteredNavItems(searchList);
    } else {
      setFilteredNavItems(navItems);
    }
  };

  const handleMenuClick = (menuItem) => {
    setCurrentMenu(menuItem);
    history.push({ search: `action=${menuItem.action}` });
  };

  return (
    <>
      <div className="ocrDemo-sider-container is-flex" style={{ width: !isMenuCollapsed ? '222px' : '52px' }}>
        <div className={`ocrDemo-recent-container ${isMenuCollapsed ? 'collapsed' : ''}`} style={{ width: !isMenuCollapsed ? '222px' : '52px' }}>
          <div className="ocrDemo-recent-container__header">
            {
              showSearch && !isMenuCollapsed ? <>
                <Input
                  value={searchVal}
                  onBlur={() => setShowSearch(false)}
                  placeholder="请描述所识别场景"
                  onChange={(e) => setSearchVal(e)}
                  onEnter={() => searchMenu(searchVal)}
                  suffixIcon={<span className="ocrDemo-icon_search" onClick={() => searchMenu(searchVal)}></span>}
                />
              </> : <>
                <Popup disabled={!isMenuCollapsed || recentMenu.length === 0} content={
                  <ul className="ocrDemo-menu-popContainer">
                    {
                      recentMenu.map(item => (
                        <li
                          key={item.action}
                          className={`${action === item.action ? 'isActive' : ''} ocrDemo-menu-popContainer__item`}
                          value={item.action}
                          onClick={() => handleMenuClick(item)}
                        >
                          <span className="t-menu__content">{item.title}</span>
                        </li>
                      ))
                    }
                  </ul>
                } placement="right" destroyOnClose>
                  <span className="ocrDemo-icon__recent" />
                </Popup>
                {
                  !isMenuCollapsed && <>
                    <span>最近访问</span>
                    <span className="ocrDemo-icon__recent-search" onClick={() => setShowSearch(true)}></span>
                  </>
                }
              </>
            }
          </div>
          {
            !isMenuCollapsed && recentMenu?.length > 0 && <div className="ocrDemo-recent-menuItem_container">
              {
                recentMenu?.map(menuItem => (
                  <div
                    key={menuItem.action}
                    className={`ocrDemo-recent-menuItem ${action === menuItem.action ? 'isOpen' : ''}`}
                    onClick={() => handleMenuClick(menuItem)}
                  >
                    {menuItem.title}
                  </div>
                ))
              }
            </div>
          }
        </div>

        <div className="menu_container">
          <Menu
            style={{ width: !isMenuCollapsed ? '222px' : '52px' }}
            value={action}
            expanded={expandedKeys}
            onExpand={(value) => setExpandedKeys(value)}
            collapsed={isMenuCollapsed}
            expandMutex
            operations={
              <div className="ocrDemo-sider-container__menuBtn">
                <span className="btn-click_container">
                  <span
                    onClick={() => setMenuCollapsed(!isMenuCollapsed)}
                    className="ocrDemo-sider-container__menuBtn_icon"
                  ></span>
                  {
                    !isMenuCollapsed && <span onClick={() => setMenuCollapsed(!isMenuCollapsed)}>收起</span>
                  }
                </span>
              </div>
            }
          >
            {filteredNavItems && filteredNavItems.map(menu => (
              <SubMenu
                key={menu?.key}
                value={menu?.key}
                title={menu.title}
                icon={<img className="ocrDemo-sider-menu__icon" src={COS_URL + menu.icon} alt="" />}
              >
                {
                  menu.children.map(item => (
                    <MenuItem
                      key={item.action}
                      value={item.action}
                      onClick={() => handleMenuClick(item)}
                    >
                      {item.title}
                    </MenuItem>
                  ))
                }
              </SubMenu>
            ))}
          </Menu>
        </div>
      </div>
    </>
  );
}
